export default __webpack_public_path__ + "static/media/Fuzzy_Mars.826b5807.mp3";